const styleSheet = (theme: any) => ({
    checkBoxWrapper:{
        padding:"10px 0 10px 0"
    },
    paddingBottom:{
        paddingBottom:"17px"
    }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Engagement/RelativeEngagement/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/containers/Filter/Engagement/RelativeEngagement/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }